import * as $ from 'jquery';

/**
 * A very simple image gallery.
 * (Note: Before anything like this should be added to NPM the hardcoded configuration needs to be
 *  removed, more hooks are needed to customize galleries, more method (e.g. gallery.next()), etc.
 *  Additionally this should be expanded to be used for 'carousels' too and we should surely first
 *  look for a good existing library to use instead of making one.)
 */
export default class Gallery {
	constructor() {

		const gallerySelector = '.gallery';
		const viewerSelector = '.gallery__view';
		const thumbnailsSelector = '.gallery__thumb';
		const itemInViewerClass = 'gallery__media';

		let $gallery = $(gallerySelector);
		if ($gallery.length === 0) {
			return;
		}

		$gallery.each(function() {
			var $elem = $(this);

			var $galleryView 	= $elem.find(viewerSelector);
			var $galleryThumb 	= $elem.find(thumbnailsSelector);

			let removeOldMediaTimeoutID: number = undefined;
			function removeOldMedia() {
				// Remove all but first one
				var $mediaElements = $galleryView.find('.' + itemInViewerClass);
				for (var i=1; i < $mediaElements.length; i++) {
					var $media = $($mediaElements[i]);
					$media.remove();
				}

				$galleryView.removeClass('loading');

				removeOldMediaTimeoutID = undefined;
			}

			function clickHandler(event: any) {
				event.preventDefault();

				var $this = $(this);
				var href = $this.attr('href');
				var alt = $this.find('img.rigid').attr('alt');
				alt = typeof alt === 'undefined' ? ' ' : alt;
				var $galleryMedia = $galleryView.find('.' + itemInViewerClass);

				if ($galleryMedia.attr('src') != href) {
					if (removeOldMediaTimeoutID !== undefined) {
						clearTimeout(removeOldMediaTimeoutID);
					}
					removeOldMedia();

					// Remove 'active' class from all thumbnails and then add to current
					$galleryThumb.removeClass('active');
					$this.parent().addClass('active');

					// Load the new media
					$galleryView.addClass('loading');
					var strImage = '<div class="' + itemInViewerClass + '"><img src="' + href + '" alt="' + alt + '" /></div>';
					$galleryView.prepend($(strImage));

					// Have media removing removed once done
					removeOldMediaTimeoutID = window.setTimeout(removeOldMedia, 1000);
				}
			}

			$galleryThumb.on('click', 'a', clickHandler);
		});
	}
} 